import { Field, TextInput } from '@carboledger/ui';
import { useTranslations } from '@/hooks';

/**
 * Props:
 *   rules  RHF rules; the slice owns the message
 */
export const GhgEmissionsField = ({ rules }) => {
  const t = useTranslations();

  return (
    <Field name="ghgEmissions" rules={rules}>
      {({ id, name, value, onChange, onBlur, status, message }) => (
        <TextInput
          id={id}
          name={name}
          label={t('FORM_GHG_EMISSIONS')}
          placeholder={t('FORM_GHG_EMISSIONS_PLACEHOLDER')}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
        />
      )}
    </Field>
  );
};

/**
 * Props:
 *   rules  RHF rules; the slice owns the message
 */
export const GhgEmissionSavingsField = ({ rules }) => {
  const t = useTranslations();

  return (
    <Field name="ghgEmissionSavings" rules={rules}>
      {({ id, name, value, onChange, onBlur, status, message }) => (
        <TextInput
          id={id}
          name={name}
          label={t('FORM_GHG_EMISSION_SAVINGS')}
          placeholder={t('FORM_GHG_EMISSION_SAVINGS_PLACEHOLDER')}
          suffix="%"
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          status={status}
          message={message}
        />
      )}
    </Field>
  );
};
